import { IGlobalConfig } from './IGlobalConfig';

declare let WS_GLOBAL_IP: string;
declare let WS_APP_DOMAIN: string;
declare let PARTNER_MODE: string;
declare let WS_APP_SCOPE: string;
declare let WS_APP_ID: string;
declare let WS_KAM_BONUS_CAPTCHA_KEY: string;
declare let WS_PROJECT_ID: string;

let globalConfig: IGlobalConfig = {
    api: '',
    appDomain: '',
    publicApplication: '',
    captchaKey: '',
    partnerMode: false,
    pageSize: 10,
    maxPageSize: 1000,
    appId: '',
    appScope: '',
    projectId: '',
    mapBoxToken: 'pk.eyJ1IjoieWFuYS1nbDgiLCJhIjoiY2xpd2dqYjE1MHJ5YTNwbzIxdGZjeWc1MSJ9.7Hb5lcMSJmxvYuAat0fz9w',
    // Для ссылки на объект оценки в QR-Quality
    qrQualityUrl: 'qr.kamgov.ru',
    // Для добавления Owner в достижения
    achievementsOrganizationId: 'e22ae603-04db-4f7c-bf18-9a607b996032',
};

const variableIsDefined = (variable: any) => typeof variable !== 'undefined';
const parseBooleanVariable = (variable: any) => variableIsDefined(variable) && !!variable && variable !== 'false';
const parseStringVariable = (variable: any, defaultValue: string) => {
    return variableIsDefined(variable) && variable ? variable : defaultValue;
}

try {
    globalConfig.api = parseStringVariable(WS_GLOBAL_IP, 'https://test.kamball.ru/api');
} catch (e) {
    globalConfig.api = 'https://test.kamball.ru/api';
}

try {
    globalConfig.appDomain = parseStringVariable(WS_APP_DOMAIN, 'https://test.kamball.ru');
} catch (e) {
    globalConfig.appDomain = 'https://test.kamball.ru';
}

try {
    globalConfig.appId = parseStringVariable(WS_APP_ID, '');
} catch (e) {
    globalConfig.appId = '';
}

try {
    globalConfig.appScope = parseStringVariable(WS_APP_SCOPE, '');
} catch (e) {
    globalConfig.appScope = '';
}

try {
    globalConfig.captchaKey = parseStringVariable(WS_KAM_BONUS_CAPTCHA_KEY, '');
} catch (e) {
    globalConfig.captchaKey = '';
}

try {
    globalConfig.partnerMode = parseBooleanVariable(PARTNER_MODE);
} catch (e) {
    globalConfig.partnerMode = false;
}

try {
    globalConfig.projectId = parseStringVariable(WS_PROJECT_ID, '');
} catch (e) {
    globalConfig.projectId = '';
}

export { globalConfig };
